
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 10.4c.5 2 3.4 4.8 5 0C9 4.4 8 2 11 2s.5 18 4 18 1-10.8 4-13.2c3-2.4 1.6 6 6 6","stroke":"#FC0","stroke-width":"3"}})])
          )
        }
      }
    